import React from "react";
import { useTranslation } from "react-i18next";

interface AuthButtonProps {
  title: string;
  onClick:()=>void;
}

const AuthButton: React.FC<AuthButtonProps> = ({ title,onClick }) => {
  const { t } = useTranslation();
  const isLogin = title === t("navigation.login");
  
  return (
    <button onClick={onClick} className={`h-14 w-full lg:w-auto flex items-center justify-center px-6 ${isLogin ? 'bg-primary_300' : 'bg-primary_500'} rounded-2xl`}>
      <p className={`semibold-text ${isLogin ? 'text-primary_500' : 'text-white'} text-nowrap`}>{title}</p>
    </button>
  );
};

export default AuthButton;
